import { render, staticRenderFns } from "./ValidatedSwitch.vue?vue&type=template&id=fa9a0604&scoped=true&"
import script from "./ValidatedSwitch.vue?vue&type=script&lang=ts&"
export * from "./ValidatedSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatedSwitch.vue?vue&type=style&index=0&id=fa9a0604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9a0604",
  null
  
)

export default component.exports